import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './auth-guard'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: require('@/views/Home').default,
    },
    // {
    //   path: '/:id/sobre',
    //   name: 'sobre',
    //   component: require('@/views/Sobre').default,
    // },
    {
      path: '/:id/login',
      name: 'login',
      component: require('@/views/Login').default
    },
    {
      path: '/:id/registro',
      name: 'registro',
      component: require('@/views/Registro').default
    },
    {
      path: '/:id/carrinho',
      name: 'carrinho',
      component: require('@/views/Carrinho').default
    },
    {
      path: '/:id/pedidos',
      name: 'pedidos',
      component: require('@/views/Pedidos').default,
      beforeEnter: AuthGuard
    },
    {
      path: '/:id/pedido',
      name: 'pedido',
      component: require('@/views/Pedido').default,
      beforeEnter: AuthGuard
    },
    {
      path: '/:id/anuncio/',
      name: 'anuncio',
      component: require('@/views/Anuncio').default,
      beforeEnter: AuthGuard
    },
    {
      path: '/:id/finalizarpedido/',
      name: 'finalizarpedido',
      component: require('@/views/FinalizarPedido').default
    },
    {
      path: '/:id/meusdados/',
      name: 'meusdados',
      component: require('@/views/MeusDados').default
    },
    {
      path: '/:id/concessionariaproxima/',
      name: 'concessionariaproxima',
      component: require('@/views/ConcessionariaProxima').default,
      beforeEnter: AuthGuard
    },
    {
      path: '/:id/trocarsenha/',
      name: 'trocarsenha',
      component: require('@/views/TrocarSenha').default,
      beforeEnter: AuthGuard
    }
  ]
})
